var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11C9.20914 11 11 9.20914 11 7C11 4.79086 9.20914 3 7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11ZM4.41124 8.88143C4.0268 8.35336 3.8 7.70317 3.8 7C3.8 5.23269 5.23269 3.8 7 3.8C7.70317 3.8 8.35336 4.0268 8.88143 4.41124L4.41124 8.88143ZM5.11831 9.58857C5.64642 9.97312 6.29672 10.2 7 10.2C8.76731 10.2 10.2 8.76731 10.2 7C10.2 6.29672 9.97312 5.64642 9.58857 5.11831L5.11831 9.58857Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBlock);
export default __webpack_public_path__ + "static/media/icn_block.a8c04c68e828ffc80388fa1aebc539dd.svg";
export { ForwardRef as ReactComponent };